import styled from 'styled-components';
import { buttonBase, getButtonAppearance, getButtonSize, getLoaderSize, stretchButton } from 'modules/buttonStyles';
export const Button = styled.button `
  ${buttonBase};
  ${stretchButton};

  ${(props) => getButtonSize(props.size)};
  ${(props) => getLoaderSize(props.size)};
  ${(props) => getButtonAppearance(props.appearance)};
`;
